export const PrivateRoutes = {
  DASHBOARD: '/dashboard',
  PROFILE: '/investors',
  USERS: '/clients',
  USER: '/expenses',
  SETTINGS: '/add-object',
  PROFILE: '/profile',
  EDIT: '/edit-profile',
  EDIT_INVESTOR: '/edit-investor',
  SETTINGS: '/settings',
}
